import request from './request'

/**
 * 更新订单任务
 * 只允许修改任务状态、进度和备注
 * @param {object} data - 任务数据
 * @param {number} data.id - 任务ID（必填）
 * @param {number} data.orderId - 订单ID（必填）
 * @param {number} [data.status] - 状态：0待开始 1进行中 2已完成 3暂停
 * @param {number} [data.progress] - 进度(0-100)
 * @param {string} [data.remark] - 备注
 */
export function updateTask(data) {
  return request.put('/order-task', data)
}

/**
 * 创建订单任务
 * @param {object} data - 任务数据
 * @param {number} data.orderId - 订单ID
 * @param {string} data.name - 任务名称
 * @param {string} [data.type] - 任务类型
 * @param {number} data.status - 状态
 * @param {number} [data.progress] - 进度
 * @param {number} [data.assigneeId] - 负责人ID
 * @param {string} [data.startTime] - 开始时间
 * @param {string} [data.endTime] - 结束时间
 * @param {string} [data.remark] - 备注
 */
export function createTask(data) {
  return request.post('/order-task', data)
}

/**
 * 删除订单任务
 * @param {number} id - 任务ID
 */
export function deleteTask(id) {
  return request.delete(`/order-task/${id}`)
}
